export default "__VITE_ASSET__QKGxb38n__"